import { render, staticRenderFns } from "./MagicLinkSent.vue?vue&type=template&id=350d9f96&scoped=true"
import script from "./MagicLinkSent.vue?vue&type=script&lang=js"
export * from "./MagicLinkSent.vue?vue&type=script&lang=js"
import style0 from "./MagicLinkSent.vue?vue&type=style&index=0&id=350d9f96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350d9f96",
  null
  
)

export default component.exports